import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _circle;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgGlovo = function SvgGlovo(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M23.255 13.348c0 .618-.345 1.672-1.147 3.092-.762 1.348-1.787 2.772-2.8 4.05-.95 1.2-2.666 1.2-3.616 0-1.013-1.278-2.038-2.702-2.8-4.05-.802-1.42-1.147-2.474-1.147-3.092a5.755 5.755 0 1 1 11.51 0Z",
      stroke: "currentColor",
      strokeWidth: 4
    })), _circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: 17.5,
      cy: 26.949,
      r: 2.458,
      fill: "currentColor"
    }))]
  }));
};
export default SvgGlovo;